var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "loading_holder" }, [
        _c("div", { staticClass: "spinner_holder" }, [_c("c-spinner")], 1)
      ])
    : _c(
        "v-container",
        [
          _c(
            "v-jumbotron",
            {
              attrs: {
                light: "",
                src: "/static/images/dashboardEmpty1.jpg",
                height: "90vh"
              }
            },
            [
              _c(
                "v-container",
                { attrs: { "fill-height": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("h3", { staticClass: "display-3 title1" }, [
                            _vm._v("Welcome")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "headline title2" }, [
                            _vm._v(
                              "Looks like you do not have any piece that you have uploaded.."
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-layout", [
                            _c(
                              "div",
                              {
                                staticClass: "text-xs-center",
                                attrs: { id: "v-step-0 v-step-1" }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      large: "",
                                      depressed: "",
                                      color: "primary",
                                      router: "",
                                      to: "/upload_an_image1"
                                    }
                                  },
                                  [_vm._v("Upload an image")]
                                ),
                                _vm._v(" "),
                                _c("v-tour", {
                                  attrs: {
                                    name: "myTour",
                                    steps: _vm.steps,
                                    callbacks: _vm.myCallbacks
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(tour) {
                                        return [
                                          _c(
                                            "transition",
                                            { attrs: { name: "fade" } },
                                            _vm._l(tour.steps, function(
                                              step,
                                              index
                                            ) {
                                              return tour.currentStep === index
                                                ? _c(
                                                    "v-step",
                                                    {
                                                      key: index,
                                                      attrs: {
                                                        step: step,
                                                        "previous-step":
                                                          tour.previousStep,
                                                        "next-step":
                                                          tour.nextStep,
                                                        stop: tour.stop,
                                                        "is-first":
                                                          tour.isFirst,
                                                        "is-last": tour.isLast,
                                                        labels: tour.labels
                                                      }
                                                    },
                                                    [
                                                      tour.currentStep === 0
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "actions"
                                                                },
                                                                slot: "actions"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      type:
                                                                        "button",
                                                                      large: "",
                                                                      depressed:
                                                                        "",
                                                                      color:
                                                                        "primary"
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        tour.nextStep
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Yes"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      type:
                                                                        "button",
                                                                      large: "",
                                                                      depressed:
                                                                        "",
                                                                      color:
                                                                        "primary"
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        tour.stop
                                                                    }
                                                                  },
                                                                  [_vm._v("No")]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      tour.currentStep === 1
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "actions"
                                                                },
                                                                slot: "actions"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      type:
                                                                        "button",
                                                                      depressed:
                                                                        "",
                                                                      color:
                                                                        "primary"
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        tour.stop
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Skip Tutorial"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      type:
                                                                        "button",
                                                                      depressed:
                                                                        "",
                                                                      color:
                                                                        "primary",
                                                                      router:
                                                                        "",
                                                                      to:
                                                                        "/upload_an_image1"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.nextStepCallback(
                                                                          tour.currentStep
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Next step"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                : _vm._e()
                                            })
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3656d9dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3656d9dd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/artist_dashboard_empty.vue
// module id = null
// module chunks = 